import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ScrollableListComponent } from '../../../shared/scrollable-list/scrollable-list.component';

@Component({
  selector: 'h3-feedback-panel',
  templateUrl: './feedback-panel.component.html',
  styleUrls: ['./feedback-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    ScrollableListComponent,
    MatIconModule,
    MatButtonModule,
  ],
})
export class FeedbackPanelComponent {
  @Input() dialogTitle = 'Feedback';
  @Output() panelClose = new EventEmitter<void>();
}
